export enum OfficePatientFilterType {
    All = "all",
    Subscribed = "subscribed",
    Active = "active",
    Invited = "invited",
    Disabled = "disabled",
}

export const officePatientFilterOptions = [
    [  "All Patients", OfficePatientFilterType.All ],
    [  "Subscribed Patients", OfficePatientFilterType.Subscribed ],
    [ "Active Patients", OfficePatientFilterType.Active ],
    [  "Invited Patients", OfficePatientFilterType.Invited ],
    [  "Disabled Patients", OfficePatientFilterType.Disabled ],
]

interface OfficePatientFilterSelectProps {
    value: OfficePatientFilterType;
    onChange: (value: OfficePatientFilterType) => void;
}

const testIds = {
    select: 'office-patient-filter-select',
    option: 'office-patient-filter-option',
};

const OfficePatientFilterSelect = ({ value, onChange }: OfficePatientFilterSelectProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(event.target.value as OfficePatientFilterType)
    }

    return (
        <select
            data-testid={testIds.select}
            className={`general-select mr-5 w-full md:w-1/4 mb-2 md:mb-0`}
            value={value}
            onChange={handleChange}
        >
            {officePatientFilterOptions.map(([ label, value ]) => (
                <option data-testid={testIds.option} key={value} value={value}>{label}</option>
            ))}
        </select>
    );
};

OfficePatientFilterSelect.testIds = testIds;

export default OfficePatientFilterSelect;
